import React, { ReactNode } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { isEmpty } from 'lodash';

const styles = {
  emptyCell: {
    textAlign: 'center',
    borderBottom: 0,
    padding: '40px',
  },
};

export type TableRowsProps = {
  emptyComponent?: string;
  children?: ReactNode;
};

const TableRows = ({ children, emptyComponent }: TableRowsProps) => {
  if (!isEmpty(children)) return <>{children}</>;
  if (emptyComponent) {
    return (
      <TableRow>
        <TableCell sx={styles.emptyCell} colSpan={20}>
          {emptyComponent}
        </TableCell>
      </TableRow>
    );
  }
  return null;
};

export { TableRows };
